import { Link } from 'react-router-dom';

export default function FinalCtaSection() {
  return (
    <section className="bg-white text-foreground-950 pb-20 md:pb-24">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px] border-t border-foreground-950/15 pt-20 md:pt-28 text-center">
          <h2 className="mx-auto max-w-[820px] font-display font-normal text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.12] tracking-[-0.015em]">
            Let&apos;s build something better together.
          </h2>
          <p className="mt-6 md:mt-8 mx-auto max-w-[520px] text-[16px] md:text-[17px] leading-[1.6] text-foreground-800">
            Whether you&apos;re growing a team or navigating change, we&apos;d love to start a conversation.
          </p>
          <Link
            to="/contact"
            className="mt-10 inline-flex items-center gap-1 text-[16px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap hover:text-accent-600 hover:border-accent-500 transition-colors cursor-pointer"
          >
            Start a conversation <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}